"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Title_1 = __importDefault(require("antd/lib/typography/Title"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Icon_1 = __importDefault(require("../Icon"));
exports.default = (function () { return (react_1.default.createElement("div", { className: "ant-app-details-area-noselecteditem" },
    react_1.default.createElement(Title_1.default, { level: 3 },
        react_1.default.createElement(Icon_1.default, { name: "arrows-chevron_left_round" }),
        react_1.default.createElement(FormatText_1.default, { id: "ui.message.master.selectItem" })))); });
